import { t } from "~/hooks/useI18n";
/**
 * Imposta un placeholder responsive per un input
 * @param inputId - L'ID dell'elemento input
 */
export function setStaticPlaceholder(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    
    if (!input) {
        console.warn(`setStaticPlaceholder: elemento con ID "${inputId}" non trovato`);
        return;
    }

    const defaultPlaceholder = t("placeholder.geographicResearch");
    const mobilePlaceholder = t("placeholder.geographicResearchMobile");

    function handleResponsivePlaceholder(): void {
        if (window.innerWidth <= 768) {
            input.setAttribute("placeholder", mobilePlaceholder);
        } else {
            input.setAttribute("placeholder", defaultPlaceholder);
        }
    }

    // Esegui subito per impostare il placeholder iniziale
    handleResponsivePlaceholder();

    window.addEventListener("resize", handleResponsivePlaceholder);
}
